<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>编辑规则</h4>
        </div>
        <div class="main-bd mg20 ">
            <el-row>
                <el-col :span="14">
                    <sub-form v-if="rule != null && rule.id > 0" :model="rule" scenario="update"
                    ></sub-form>
                </el-col>
            </el-row>
        </div>

    </div>
</template>

<script>
    import subForm from "~/views/login-rules/ruleForm.vue"
    import RuleService from "~/services/Rule";


    export default {
        name: "ruleUpdate",
        components: {
            subForm
        },
        data() {
            return {
                rule: null
            }
        },
        created() {
            this.getRule(this.$route.query["id"]);
        },

        methods: {
            getRule(id) {
                if (parseInt(id) > 0) {
                    RuleService.view(id).then(res => {
                        if (res.code == 0) {
                            let model = res.data;
                            this.rule = {
                                id: parseInt(model.id),
                                type:model.type,
                                allow_range: Array.isArray(model.allow_user_rang)
                                    ? model.allow_user_rang.map(item => Number(item))
                                    : [],
                                rule_name:model.rule_name,
                                start_day_text:model.start_day_text,
                                start_day:model.start_day,
                                end_day:model.end_day,
                                end_day_text:model.end_day_text,
                                rule_type:model.rule_type
                            }

                        }
                    })
                } else {
                    return null;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/login-rules/ruleUpdate.vue